<template>
    <el-drawer title="发送短信通知" :visible.sync="drawerShow" :wrapperClosable="false" :destroy-on-close="true" size="400px"
        @close="close">
            <div class="drawer-content">
                <el-form :model="formData" ref="formData" :rules="rules" label-position="top" size="medium">
                    <el-form-item prop="type" label="通知类型：">
                        <el-radio-group v-model="formData.type">
                            <el-radio :label="0">疫情防控提示</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item prop="objectId" label="演出：">
                        <el-input v-model="formData.objectId" placeholder="请填写演出ID" @input="onInput">
                            <el-button slot="append" icon="el-icon-search" @click="remoteShow()" :loading="remoteLoading">解析</el-button>
                        </el-input>
                        <div v-if="activity" class="MT10">
                            <div><span class="color-info">演出名称：</span>{{activity.title}}</div>
                            <div><span class="color-info">演出场地：</span>{{activity.city}} {{activity.site}}</div>
                        </div>
                    </el-form-item>
                    <el-form-item prop="name">
                        <span slot="label">通知名称：<small>该名称不会显示给用户，仅用于内部展示</small></span>
                        <el-input v-model="formData.name" maxlength="40"></el-input>
                    </el-form-item>
                    <el-form-item prop="content" label="通知内容：">
                        <el-input v-model="formData.content" type="textarea" maxlength="140" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="短信最终展示内容预览：">
                        <div style="line-height:1.5">疫情防控提示：为确保您能顺利入场观看演出（{{activity && activity.title}}），需要遵循以下规则：{{formData.content}}。如有疑问请登录秀动APP联系在线客服</div>
                    </el-form-item>
                </el-form>
                <div class="color-danger"><span class="el-icon-warning"></span> 短信将发送给演出的观演人</div>
            </div>
            <div class="drawer-footer">
                <el-button @click="close">关闭</el-button>
                <el-button type="primary" @click="submitForm()" :loading="btnLoading"
                >确认发送</el-button
            >
            </div>
    </el-drawer>
</template>
<script>
const defaultFormData = {
    "activityName": "",
    "content": "",
    "name": "",
    "objectId": "",
    "objectType": 1,
    "type": 0
}
export default {
    data(){
        return{
            drawerShow:false,
            btnLoading:false,
            formData:{...defaultFormData},
            rules:{
                name:[{ required: true, message: "请填写通知名称" }],
                objectId: [{ required: true, message: "请填写演出ID并解析" }],
                content: [{ required: true, message: "请填写通知内容" }],
            },
            activity: null,
            remoteLoading: false
        }
    },
    methods:{
        show(){
            this.drawerShow = true;
        },
        close(){
            this.formData = {...defaultFormData};
            this.$nextTick(() => {
                this.$refs.formData.resetFields();
                this.$refs.formData.clearValidate()
            })
            this.drawerShow = false;
        },
        onInput(value) {
            if (!/^[0-9]+$/.test(value)) this.formData.objectId = '';
        },
        //解析演出
        async remoteShow(){
            this.remoteLoading = true;
            const res = await this.$request({
                url: '/message/notify/activityInfo',
                method: 'post',
                params: {activityId: this.formData.objectId}
            }).catch(() => {
                return {data: {state: '0', msg: '请求错误'}};
            }).finally(() => {
                this.remoteLoading = false;
            });

            const { state , result,  msg } = res.data;
            if(state == 1 && result){
                this.activity = result;
            }else{
                this.activity = null;
                this.$message.error(msg || '请求错误');
            }
        },
        //表单提交
        submitForm(){
            this.$refs["formData"].validate( async (valid) => {
                if(valid){
                    if( !this.activity ){
                        return this.$message.error('请解析演出');
                    }
                    this.btnLoading = true;
                    this.$request({
                        url: "/message/notify/send",
                        method: "POST",
                        data: {
                            ...this.formData,
                            activityName: this.activity.title,
                            objectId: this.activity.id
                        },
                    })
                    .then((res) => {
                        const { state, msg } = res.data;
                        if ( state == 1) {
                            this.$emit('onUpdate');
                            this.close();
                        } else {
                            this.$message.error(msg || "请求失败");
                        }
                    })
                    .catch(() => {
                        this.$message.error("请求错误");
                    })
                    .finally(() => {
                        this.btnLoading = false;
                    });
                }else{
                    return false;
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>

</style>